(() => {
  if (customElements.get('ttc-product-specifications')) return;
  customElements.define('ttc-product-specifications', class extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
        if (String(data?.sectionId) !== this.dataset.sectionId) return;
        const id = String(data?.variant?.id || '');
        const template = [...this.querySelectorAll('template[data-specifications-variant]')]
          .find(item => item.dataset.specificationsVariant === id) || this.querySelector('template[data-specifications-default]');
        const body = this.querySelector('tbody');
        if (!template || !body) return;
        body.replaceChildren(template.content.cloneNode(true));
        this.hidden = !body.querySelector('tr');
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); this.unsubscribe = null; }
  });
})();
